<template lang="pug">
v-container.px-sm-8.py-sm-4
  v-row.mt-2(align="center")
    v-col(cols="12" sm="5")
      .d-flex.align-center
        v-text-field.round-lg.search-input(v-model="searchText" @input="queryChanged" :placeholder="$t('search_member')" hide-details dense solo flat height=40 background-color="neutral300")
          template(v-slot:append)
            eva-icon(name="search-outline" :fill="$colors.primary400")
        v-btn.ml-3(v-if="isMobileScreen" @click="inviteUser" outlined icon color="info")
          v-icon mdi-plus
    v-col(cols="12" sm="7" v-if="!isMobileScreen")
      .text-right
        v-btn.button-md(@click="inviteUser" color="info500" outlined)
          eva-icon.mr-2.ml-n1(name="plus-outline" :fill="$colors.info500" width="20" height="20" style="margin-top: 3px")
          span {{ $t('new_user') }}
  v-chip.mt-2.primary400--text(outlined @click="clickPendingInvites" v-if="invitations.length") ({{ invitations.length }}) {{ $t('pending_invites') }}

  v-row(align="center" v-if="!isMobileScreen")
    v-col(cols="12" md="6")
      .d-flex.align-center
        v-btn.button-sm.mr-4(v-if="selected.length" @click="deleteMember" color="danger500" outlined) {{ $t('delete') }}
        a.link-s(v-if="selected.length" @click="clearSelection") {{ $t('clear_selection') }}
        v-spacer
  .mt-3(v-else)
    template(v-if="!isLoading")
      v-divider
      .d-flex.align-center.py-3
        yc-checkbox(v-model="checkAll" @change="onCheckedAll")
        v-menu(v-if="selected.length" offset-y)
          template(v-slot:activator="{ on, attrs }")
            v-btn.button-sm(v-on="on" text) {{ $t('action') }} ({{ selected.length }})
              v-icon.ml-1(small) mdi-chevron-down
          v-list.text-sm
            v-list-item(@click="deleteMember")
              .danger500--text {{ $t('delete') }}
            v-list-item(@click="clearSelection")
              div {{ $t('clear_selection') }}
      v-divider
  .text-center(v-if="isLoading")
    v-progress-circular.mt-8(width="2" size="50" color="primary" indeterminate)
  
  .yc-table(v-else)
    v-data-table.mt-2(:headers="headers" :items="members" item-key="id" :hide-default-header="isMobileScreen" hide-default-footer disable-sort :items-per-page="-1")
      template(v-slot:no-data)
        .mt-16
          v-img.mx-auto(src="@/assets/images/icon_empty.png" width=80)
          .mt-2 {{ $t('no_members_available') }}
      template(v-slot:header.checked)
        yc-checkbox(v-model="checkAll" @change="onCheckedAll")
      template(v-slot:item="{ item, isMobile, headers }")
        tr.primary--text(v-if="!isMobile")
          td(v-for="header in headers")
            template(v-if="header.value === 'checked'")
              yc-checkbox(v-model="item.checked" @change="onChecked" v-if="item.role !== 'Admin'")
            template(v-if="header.value ===  'user'")
              .font-medium {{ `${item.user.first_name} ${item.user.last_name}` }}
            template(v-if="header.value ===  'role'")
              div {{ item.role }}
            template(v-if="header.value ===  'email'")
              div {{ item.user.email }}
            template(v-if="header.value === 'status'")
              y-switch.mt-3(v-model="item.isActive" @change="onToggle(item)" :disabled="!item.isActive && reachUserCountLimit")
            template(v-if="header.value === 'action'")
              .text-center
                v-btn.button-sm(@click="onEdit(item)" color="primary" outlined) {{ $t('edit') }}
        
        template(v-else)
          .d-flex.py-3.align-start
            yc-checkbox(v-model="item.checked" @change="onChecked" v-if="item.role !== 'Admin'")
            .ml-5(v-else)
            .ml-4.flex-grow-1.text-sm
              .d-flex
                .font-medium.primary500--text.flex-grow-1 {{ `${item.user.first_name} ${item.user.last_name}` }}
                v-menu(offset-y min-width=72)
                  template(v-slot:activator="{ on }")
                    v-btn(v-on="on" icon small)
                      v-icon mdi-dots-horizontal
                  v-list(dense)
                    v-list-item(@click="onEdit(item)")
                      .text-sm {{ $t('edit') }}
              .d-flex.mb-1.align-center
                .flex-grow-1.basic600--text {{ $t('email') }}
                div {{ item.user.email }}
              .d-flex.mb-1.align-center
                .flex-grow-1.basic600--text {{ $t('role') }}
                div {{ item.role }}
              .d-flex.mb-1.align-center
                .flex-grow-1
                  .basic600--text {{ $t('activate_member') }}
                .mt-1
                  y-switch.mr-n2.mb-n2(v-model="item.isActive" @change="onToggle(item)" :disabled="!item.isActive && reachUserCountLimit")
          v-divider

  invite-connect-member(v-if="showInviteDialog" :open.sync="showInviteDialog" @invited="fetchInvitations")
  pending-connect-member(v-if="showPendingDialog" :open.sync="showPendingDialog" @updated="fetchInvitations")
  remove-connect-member(v-if="showDeleteDialog" :open.sync="showDeleteDialog" :members="selected" @deleted="onDeleted")
  edit-connect-member(v-if="showEditDialog" :open.sync="showEditDialog" :member="selectedMember" @edited="fetchMembers")
  
</template>

<script>
import { debounce } from '@/utils'
import { mapGetters, mapActions, mapState } from 'vuex'
import InviteConnectMember from '@/components/connect/dialogs/InviteConnectMember.vue'
import PendingConnectMember from '@/components/connect/dialogs/PendingConnectMember.vue'
import RemoveConnectMember from '@/components/connect/dialogs/RemoveConnectMember.vue'
import EditConnectMember from '@/components/connect/dialogs/EditConnectMember.vue'

export default {
  components: { 
    InviteConnectMember, 
    PendingConnectMember,
    RemoveConnectMember,
    EditConnectMember
  },
  data: () => ({
    isLoading: false,
    searchText: '',
    selected: [],
    checkAll: false,
    headers: [
      { text: '', value: 'checked' },
      { text: 'Name', value: 'user' },
      { text: 'Role', value: 'role' },
      { text: 'Email', value: 'email' },
      { text: 'Activate member', value: 'status' },
      { text: '', value: 'action' }
    ],
    members: [],
    invitations: [],
    selectedMember: null,
    showInviteDialog: false,
    showPendingDialog: false,
    showDeleteDialog: false,
    showEditDialog: false,
    activeMemberCount: 0
  }),
  computed: {
  ...mapState('subscriptions', ['connectSubscription']),
    ...mapGetters({ company: 'getCompany' }),
    isMobileScreen () {
      return this.$vuetify.breakpoint.xs
    },
    reachUserCountLimit () {
      const maxCount = this.connectSubscription?.limitations?.user || 0
      if (maxCount === -1 || this.activeMemberCount < maxCount) {
        return false
      }
      return true
    }
  },
  created () {
    this.headers.map(item => item['class'] = 'text-table-header')
    this.fetchMembers()
    this.fetchInvitations()
    this.fetchActiveMemberCount()
  },
  methods: {
    ...mapActions(['showMessage']),
    onCheckedAll(checked) {
      const clone = [...this.members]
      clone.map(item => item.checked = checked)
      this.members = [...clone]
      this.selected = this.members.filter(item => item.checked === true && item.role !== 'Admin')
    },
    queryChanged: debounce(function (query) {
      this.fetchMembers(query)
    }, 750),
    onToggle (item) {
      const status = item.isActive ? 'active' : 'inactive'
      const word = item.isActive ? 'active' : 'inactivate'
      this.$axios.patch(`/members/${item.id}/`, { status })
        .then(resp => {
          const status = resp.data.status
          this.$set(item, 'status', status)
          this.updateActiveMemberCount(status)
          this.showMessage(['success', `Member ${word} successful.`])
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
    },
    onChecked () {
      this.selected = this.members.filter(item => item.checked === true && item.role !== 'Admin')
      this.checkAll = false
    },
    clearSelection () {
      this.checkAll = false
      this.onCheckedAll(false)
    },
    onEdit (item) {
      this.selectedMember = item
      this.showEditDialog = true
    },
    onDeleted () {
      this.clearSelection()
      this.fetchMembers()
    },
    deleteMember () {
      this.showDeleteDialog = true
    },
    inviteUser () {
      if (this.reachUserCountLimit) {
        this.showMessage(['upgrade'])
        return
      }
      this.showInviteDialog = true
    },
    clickPendingInvites () {
      if (this.reachUserCountLimit) {
        this.showMessage(['upgrade'])
        return
      }
      this.showPendingDialog = true
    },
    updateActiveMemberCount (status) {
      if (status === 'active') {
        this.activeMemberCount++
      } else {
        this.activeMemberCount--
      }
    },
    fetchMembers (query) {
      this.isLoading = true
      this.$axios.get(`/members/?company=${this.company.id}&page_size=-1&app=connect&search=${query || ''}`)
        .then(resp => {
          this.members = resp.data.results?.map(item => {
            item.isActive = item.status === 'active' ? true : false
            return item
          })
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    fetchInvitations () {
      this.$axios.get(`/invitations/?company=${this.company.id}&role=5&page_size=-1&accepted=false&ordering=id`, )
        .then(resp => {
          this.invitations = []
          if (resp.data?.results) {
            this.invitations =  resp.data.results
          }
        })
    },
    fetchActiveMemberCount () {
      this.$axios.get(`/connect/${this.company.slug}/settings`)
        .then(resp => {
          this.activeMemberCount = resp.data.active_member_count
        })
        .catch(() => {})
    }
  }
}
</script>
